var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",on:{"click":_vm.clickOutSide}},[_c('side-bar',[_c('template',{slot:"topLogo"},[_c('span',{staticClass:"rounded-circle d-flex flex-column align-items-center"},[_c('img',{attrs:{"alt":"Image placeholder","src":`${_vm.publicPath}/img/rcp/${_vm.merchant_logo?_vm.merchant_logo:'logo.svg'}`}})])]),_c('template',{slot:"links"},[(_vm.isNavActive)?_c('div',{staticClass:"role-toggle-switch mb-3",class:{
          'd-none': !_vm.partnerStatus,
        }},[_c('div',{staticClass:"toggle-options"},[_c('label',{class:{ active: _vm.roleToggle === 'member' },on:{"click":function($event){return _vm.setRole('member')}}},[_vm._v("\n            "+_vm._s(_vm.$t("Member"))+"\n          ")]),_c('label',{class:{ active: _vm.roleToggle === 'partner' },on:{"click":function($event){return _vm.setRole('partner')}}},[_vm._v("\n            "+_vm._s(_vm.$t("Partner"))+"\n          ")]),_c('div',{staticClass:"toggle-slider",class:_vm.roleToggle})])]):_vm._e(),(_vm.isNavActive && _vm.partnerStatus === 1 && _vm.roleToggle === 'partner')?[(
            _vm.isFirstTime == 'false' && _vm.kycApprove && _vm.haveCard && !_vm.profileStatus
          )?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Dashboard'),
            path: '/account',
            imageicon: 'dashboard-svgrepo-com.svg',
          }}}):_vm._e(),(!_vm.isSuspend && _vm.isFirstTime == 'false' && !_vm.profileStatus)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('QR Transaction'),
            path: '/qr-transaction',
            imageicon: 'card-management.png',
          }}}):_vm._e(),(!_vm.isSuspend && _vm.isFirstTime == 'false' && !_vm.profileStatus)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Withdrawal'),
            path: '/withdrawal',
            imageicon: 'withdraw-svgrepo-com.svg',
          }}}):_vm._e(),(!_vm.isSuspend && _vm.isFirstTime == 'false' && _vm.kycApprove)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Report'),
            path: '/report',
            imageicon: 'report.png',
          }}},[(
              _vm.isFirstTime == 'false' &&
              _vm.kycApprove &&
              _vm.haveCard &&
              !_vm.profileStatus &&
              _vm.domain_info.merchant_deposit != 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('QR Transaction'),
              path: '/qr-transaction-report',
            }}}):_vm._e(),(
              _vm.isFirstTime == 'false' &&
              _vm.kycApprove &&
              _vm.haveCard &&
              !_vm.profileStatus &&
              _vm.domain_info.merchant_deposit != 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Withdrawal'),
              path: '/withdrawal-report',
            }}}):_vm._e()],1):_vm._e(),(!_vm.isSuspend)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Settings'),
            path: '/settings',
            imageicon: 'settings.png',
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Change Password'),
              path: '/change-password',
            }}}),(_vm.isFirstTime == 'false')?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('System Configuration'),
              path: '/system-configuration',
            }}}):_vm._e()],1):_vm._e(),(!_vm.isSuspend && _vm.chat == 1)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Customer Service'),
            path: '/cs',
            imageicon: 'cs.png',
          }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('FAQ'),
            path: '/faq',
            imageicon: 'faq.svg',
          }}}),_c('sidebar-item',{staticClass:"logout",attrs:{"link":{
            name: _vm.$t('Logout'),
            path: '/logout',
            imageicon: 'logout.png',
          }}})]:[(
            _vm.isFirstTime == 'false' &&
            _vm.kycApprove &&
            _vm.haveCard &&
            !_vm.profileStatus &&
            _vm.domain_info.merchant_deposit != 1
          )?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Deposit'),
            path: '/deposit',
            imageicon: 'wallet-add.svg',
          }}}):_vm._e(),(
            !_vm.isSuspend &&
            _vm.isFirstTime == 'false' &&
            _vm.kycApprove &&
            _vm.haveCard &&
            !_vm.profileStatus
          )?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Card Transfer'),
            path: '/transfer',
            imageicon: 'transfer-side-nav3.svg',
          }}}):_vm._e(),(
            _vm.isNavActive &&
            !_vm.isSuspend &&
            _vm.isFirstTime == 'false' &&
            _vm.kycApprove &&
            _vm.haveCard &&
            !_vm.profileStatus
          )?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('QR Transaction'),
            path: '/qr-transaction',
            imageicon: 'card-management.png',
          }}}):_vm._e(),(!_vm.isSuspend && _vm.isFirstTime == 'false' && !_vm.profileStatus)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Upload Documents (eKYC)'),
            path: '/kyc',
            imageicon: 'kyc.png',
          }}}):_vm._e(),(
            !_vm.isSuspend &&
            _vm.isFirstTime == 'false' &&
            _vm.kycApprove &&
            !_vm.profileStatus
          )?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Card Management'),
            path: '/card-management',
            imageicon: 'card-management.png',
          }}}):_vm._e(),(!_vm.isSuspend)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Settings'),
            path: '/settings',
            imageicon: 'settings.png',
          }}},[(_vm.isFirstTime == 'false')?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Edit Profile'),
              path: '/edit-profile',
            }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Change Password'),
              path: '/change-password',
            }}}),(_vm.isFirstTime == 'false')?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('System Configuration'),
              path: '/system-configuration',
            }}}):_vm._e()],1):_vm._e(),(!_vm.isSuspend && _vm.isFirstTime == 'false' && _vm.kycApprove)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Report'),
            path: '/report',
            imageicon: 'report.png',
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Transaction'),
              path: '/transaction',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Deposit'),
              path: '/deposit-report',
            }}}),(
              _vm.isFirstTime == 'false' &&
              _vm.kycApprove &&
              _vm.haveCard &&
              !_vm.profileStatus &&
              _vm.domain_info.merchant_deposit != 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('Transfer'),
              path: '/transfer-report',
            }}}):_vm._e()],1):_vm._e(),(
            _vm.isNavActive &&
            _vm.isFirstTime == 'false' &&
            _vm.kycApprove &&
            _vm.haveCard &&
            !_vm.profileStatus &&
            !_vm.partnerStatus
          )?_c('sidebar-item',{attrs:{"link":{
            name: _vm.partnershipMenuText,
            path: '/account',
            imageicon: 'account.svg',
          }}}):_vm._e(),(!_vm.isSuspend && _vm.chat == 1)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('Customer Service'),
            path: '/cs',
            imageicon: 'cs.png',
          }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('FAQ'),
            path: '/faq',
            imageicon: 'faq.svg',
          }}}),_c('sidebar-item',{staticClass:"logout",attrs:{"link":{
            name: _vm.$t('Logout'),
            path: '/logout',
            imageicon: 'logout.png',
          }}})]],2)],2),_c('div',{staticClass:"main-content"},[_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[(_vm.company_logo)?_c('div',{staticClass:"d-none d-md-block top-logo-in-content"},[_c('img',{staticClass:"mr-5 mt-2 company-logo",attrs:{"alt":"Image placeholder","src":`${_vm.publicPath}/img/rcp/${_vm.company_logo}.png`}})]):_vm._e(),_c('notifications',{attrs:{"position":"top right"}}),_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view',{key:_vm.routerKey,ref:"currentPage"})],1),(_vm.chat == 1 && !_vm.visibleChat)?_c('floating-chat-icon',{attrs:{"icon":"","isActive":_vm.showChat},on:{"toggle-chat":_vm.toggleChat}}):_vm._e(),(!_vm.visibleChat && _vm.showChat && _vm.chat == 1)?_c('floating-chat',{attrs:{"isFloating":true},on:{"toggle-chat":_vm.toggleChat,"is-connect":_vm.isReadyToChat}}):_vm._e()],1)]),_c('b-modal',{attrs:{"id":"modal-scarm-alert","title":"Reminder","hide-footer":""},on:{"hide":function($event){return _vm.$bvModal.hide('modal-scarm-alert')}},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_vm._v("\n      "+_vm._s(_vm.$t(""))+"\n    ")]},proxy:true}])},[_c('div',{staticClass:"text-center pb-3"},[_c('VueSlickCarousel',{attrs:{"arrows":true,"dots":true,"adaptiveHeight":true}},[(_vm.maintenance)?_c('div',{staticClass:"mt-1"},[_c('span',{staticClass:"bell fa fa-bell",staticStyle:{"width":"3rem !important","height":"3rem !important"}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.maintenance['message'])}})]):_vm._e(),_c('div',[_c('img',{staticClass:"w-100 px-2 mb-2",staticStyle:{"border-radius":"30px !important"},attrs:{"alt":"Image placeholder","src":`${_vm.publicPath}/img/rcp/otp-banner.jpg?v=1.0`}}),_c('div',{staticClass:"text-center mb-4"},[_c('h3',[_vm._v(_vm._s(_vm.$t("We've Enhanced OTP Delivery")))]),_c('p',[_vm._v("\n              "+_vm._s(_vm.$t(
                  "You can now receive OTPs via SMS, email, in-app, and on our web platform."
                ))+"\n            ")]),_c('p',[_vm._v("\n              "+_vm._s(_vm.$t(
                  "Access your OTP securely through the method that suits you best. Thank you for using RCPAY."
                ))+"\n            ")])])]),_c('div',[_c('img',{staticClass:"w-100 px-2",attrs:{"alt":"Image placeholder","src":`${_vm.publicPath}/img/rcp/popup-image-dashboard.png`}}),_c('h2',{staticClass:"fz-28 fz-xs-23 text-center mx-auto my-2 d-block px-md-5 mx-md-2"},[_vm._v("\n            "+_vm._s(_vm.$t("New Feature launching on December 9th!"))+"\n          ")]),_c('p',[_vm._v("\n            "+_vm._s(_vm.$t(
                "Unlock a world of possibilities with the RC365 Asset Link Credit Card."
              ))+"\n          ")]),_c('p',{staticClass:"text-center px-3",domProps:{"innerHTML":_vm._s(_vm.$t('new-feature-transfer-1'))}})])])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }